import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { microFormats } from '../data/microFormats';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        Propuesta de valor
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Salud visual con autoridad de medios
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Óptica Berlud no necesita solo un spot aislado: necesita estar donde la audiencia confía en la información y el bienestar.
        TNO Network convierte esa confianza en recordación diaria, credibilidad periodística y contenido que sigue trabajando en Google y en redes.
      </Typography>

      <Box sx={{ '& > div': { mb: 2 } }}>
        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Noticias TNO — el noticiero
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Con Sol Vargas, la marca llega al espacio informativo de mayor prestigio del ecosistema: menciones, cintillos semanales
            y tips de salud visual con tono periodístico, no publicitario.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Rotativa + Digest + inserts
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Cada plan escala el inventario clave de comercialización:
          </Typography>
          <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 0 }}>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Más rotativas:</strong> de 6 a 12 impactos diarios en la señal Radio Visual 24/7.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Más Digest:</strong> de 1 a 4 artículos SEO mensuales en tnonetwork.com.
            </Typography>
            <Typography component="li" variant="body2" color="textSecondary">
              <strong>Más inserts en redes:</strong> de 2 a 12 piezas con logo y claqueta en Reels, Shorts y clips TNO.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
          Micros sin ir a la óptica — ¿qué podemos hacer?
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          En Plata y Oro incluimos micros en video producidos por TNO sin grabar en sucursal. Estas son las opciones habituales:
        </Typography>
        <Grid container spacing={2}>
          {microFormats.map((item) => (
            <Grid item xs={12} sm={6} key={item.title}>
              <Box
                sx={{
                  p: 2,
                  height: '100%',
                  borderRadius: 1,
                  bgcolor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Typography variant="subtitle2" color="primary" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        El beneficio para Óptica Berlud
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Una sola alianza mensual que cubre noticiero, señal continua, autoridad en buscadores y presencia visual en redes —
        con planes claros para crecer de Bronce a Oro según el presupuesto y la ambición comercial.
      </Typography>
    </Box>
  );
};

export default OportunidadSection;
